import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CollectionsV2Service } from '../../../../../services/collectionsV2.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { ProductsService } from '../../../../../services/products.service';
import { TranslateService } from '@ngx-translate/core';

declare const google: any;

@Component({
  selector: 'app-delivery-area-config',
  templateUrl: './delivery-area-config.component.html',
  styleUrls: ['./delivery-area-config.component.scss'],
})
export class DeliveryAreaConfigComponent implements OnInit {
  @Input() data;
  @Input() areas;
  @Input() linkedPartners;
  @Input() isWorkshop: boolean = true;
  @Input() isRentals: boolean = false;
  @Output() close = new EventEmitter();
  public saving = false;
  public selectedPartners: any = [];
  //public linkedProducts: any = [];
  pointList: { lat: number; lng: number }[] = [];
  drawingManager: any;
  selectedShape: any;
  public currentStoreCoords: { lat: number; lng: number };
  public newSku: any = null;
  public searchResult: any = [];
  public products: any = [];
  public showAllMaps : boolean = true;

  areaColours: { id: number; area: string; colour: string; showOnMap: boolean }[] = [];
  public overlays : any = [];
  public globalMap : any;

  constructor(
    private collectionsService: CollectionsV2Service,
    private helpersService: HelpersService,
    private translate: TranslateService,
    private productsService: ProductsService,
  ) { }

  ngOnInit() {
    var partner = this.helpersService.getPartnerData();
    this.currentStoreCoords = { lat: partner.Latitude, lng: partner.Longitude };

    if (this.data.linkedPartners) {
      this.selectedPartners = this.data.linkedPartners.map((x) => {
        return x.partnerID.toString();
      });
    }

    this.areaColours = [];
    for (var i = 0; i < this.areas.length; i++) {
      var randomColor = Math.floor(Math.random() * 16777215).toString(16);
      this.areaColours.push({
        id: this.areas[i].id,
        area: this.areas[i].areaName,
        colour: '#' + randomColor,
        showOnMap: true
      });
    }
    this.areaColours = this.areaColours.sort((x,y)=>{
      if(x.area > y.area) return 1;
      if(x.area < y.area) return -1;
      return 0;
    })
  }

  valid() {
    return (
      this.data.areaName &&
      this.pointList &&
      this.pointList.length > 0 &&
      this.selectedPartners.length > 0
    );
  }

  save() {
    this.saving = true;
    if (this.data.id) {
      this.data.linkedPartners = this.selectedPartners.map((x) => {
        return { partnerID: x };
      });
      this.data.areaCoordinates = this.pointList.map((x) => {
        return [x.lat, x.lng];
      });
      this.data.collectionSKU =
        this.data.collectionProduct && this.data.collectionProduct.sku
          ? this.data.collectionProduct.sku
          : null;
      this.data.deliverySKU =
        this.data.deliveryProduct && this.data.deliveryProduct.sku
          ? this.data.deliveryProduct.sku
          : null;
      this.collectionsService.updateDeliveryAreas(this.data).subscribe(
        (res) => {
          this.saving = false;
          this.close.emit('');
        },
        (err) => {
          this.saving = false;
        },
      );
    } else {
      this.data.linkedPartners = this.selectedPartners.map((x) => {
        return { partnerID: x };
      });
      this.data.areaCoordinates = this.pointList.map((x) => {
        return [x.lat, x.lng];
      });
      this.data.collectionSKU =
        this.data.collectionProduct && this.data.collectionProduct.sku
          ? this.data.collectionProduct.sku
          : null;
      this.data.deliverySKU =
        this.data.deliveryProduct && this.data.deliveryProduct.sku
          ? this.data.deliveryProduct.sku
          : null;
      this.collectionsService
        .addDeliveryAreas(this.helpersService.getPartnerId(), this.data)
        .subscribe(
          (res) => {
            this.saving = false;
            this.close.emit('');
          },
          (err) => {
            this.saving = false;
          },
        );
    }
  }

  onMapReady(map) {
    this.globalMap = map;
    this.initDrawingManager(map);
  }

  updatePointList(path) {
    this.pointList = [];
    const len = path.getLength();
    for (let i = 0; i < len; i++) {
      this.pointList.push(path.getAt(i).toJSON());
    }
  }

  initDrawingManager = (map: any) => {
    const self = this;
    var options = {
      drawingControl: true,
      drawingControlOptions: {
        drawingModes: ['polygon']
      },
      fullscreenControl: true,
      polygonOptions: {
        draggable: true,
        editable: true,
        strokeColor: '#EE3158',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#EE3158',
        fillOpacity: 0.35,
      },
      drawingMode: google.maps.drawing.OverlayType.POLYGON,
    };

    this.drawingManager = new google.maps.drawing.DrawingManager(options);
    this.drawingManager.setMap(map);


    google.maps.event.addListener(
      this.drawingManager,
      'overlaycomplete',
      (event) => {
        if (event.type === google.maps.drawing.OverlayType.POLYGON) {
          const paths = event.overlay.getPaths();
          for (let p = 0; p < paths.getLength(); p++) {
            google.maps.event.addListener(paths.getAt(p), 'set_at', () => {
              if (!event.overlay.drag) {
                self.updatePointList(event.overlay.getPath());
              }
            });
            google.maps.event.addListener(paths.getAt(p), 'insert_at', () => {
              self.updatePointList(event.overlay.getPath());
            });
            google.maps.event.addListener(paths.getAt(p), 'remove_at', () => {
              self.updatePointList(event.overlay.getPath());
            });
          }
          self.updatePointList(event.overlay.getPath());
          this.selectedShape = event.overlay;
          this.selectedShape.type = event.type;
        }
        if (event.type !== google.maps.drawing.OverlayType.MARKER) {
          // Switch back to non-drawing mode after drawing a shape.
          self.drawingManager.setDrawingMode(null);
          // To hide:
          self.drawingManager.setOptions({
            drawingControl: false,
          });
        }
      },
    );

    if (this.data.id) {
      this.data.areaCoordinates.forEach((coord, index) => {
        this.pointList.push({ lat: coord[0], lng: coord[1] });
      });
      var polyOptions = {
        paths: this.pointList,
        editable: true,
        draggable: false,
        strokeColor: '#EE3158',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#EE3158',
        fillOpacity: 0.75,
        //zIndex: 999
      };
      var polygon = new google.maps.Polygon(polyOptions);
      polygon.setMap(map);
      this.addListenersOnPolygon(polygon);
      this.selectedShape = polygon;
      this.selectedShape.type = 'polygon';
      self.drawingManager.setDrawingMode(null);
      self.drawingManager.setOptions({
        drawingControl: false,
      });

      for (var i = 0; i < this.areas.length; i++) {

        if (this.areaColours.find((x) => x.id == this.areas[i].id).showOnMap) {

          var points: { lat: number; lng: number }[] = [];
          if (this.areas[i].id !== this.data.id) {
            this.areas[i].areaCoordinates.forEach((coord, index) => {
              points.push({ lat: coord[0], lng: coord[1] });
            });

            var polyOptions = {
              paths: points,
              editable: false,
              draggable: false,
              strokeColor: this.areaColours.find((x) => x.id == this.areas[i].id)
                .colour,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: this.areaColours.find((x) => x.id == this.areas[i].id)
                .colour,
              fillOpacity: 0.25,
              //zIndex: 100+i
            };
            var polygon = new google.maps.Polygon(polyOptions);
            polygon.setMap(map);
            this.selectedShape = polygon;
            this.selectedShape.type = 'polygon';
            this.overlays.push(polygon);
            //self.drawingManager.setDrawingMode(null);
            //self.drawingManager.setOptions({
            //  drawingControl: false,
            //});
          }
        }
      }
    } else {
      for (var i = 0; i < this.areas.length; i++) {
        //console.log(this.areas[i].areaName);
        if (this.areaColours.find((x) => x.id == this.areas[i].id).showOnMap) {
          var points: { lat: number; lng: number }[] = [];

          this.areas[i].areaCoordinates.forEach((coord, index) => {
            points.push({ lat: coord[0], lng: coord[1] });
          });

          var polyOptions = {
            paths: points,
            editable: false,
            draggable: false,
            strokeColor: this.areaColours.find((x) => x.id == this.areas[i].id)
              .colour,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: this.areaColours.find((x) => x.id == this.areas[i].id)
              .colour,
            fillOpacity: 0.25,
            //zIndex: 100+i
          };
          var polygon = new google.maps.Polygon(polyOptions);
          polygon.setMap(map);
          this.selectedShape = polygon;
          this.selectedShape.type = 'polygon';

          //const bounds = new google.maps.LatLngBounds();
          //const p = polygon.getPaths();
          //for (let pp = 0; pp < p.getLength(); pp++) {
          //  var a = p.getAt(pp);
          //  for (var c = 0; c < length; c++) {
          //    bounds.extend(a.Uc[c].toJSON());
          //  }
          //}
          //const image = "https://aux4.iconspalace.com/uploads/9326358081268318372.png";
          //const center = bounds.getCenter();
          //console.log(center.toJSON());
          //const markerOptions = {
          //  position: center,
          //  label: this.areas[i].areaName,
          //  title: this.areas[i].areaName,
          //  animation: google.maps.Animation.DROP,
          //  map: map,
          //  icon: image
          //};
          //var marker = new google.maps.Marker(markerOptions);
        }
      }
    }

    if (this.linkedPartners && this.linkedPartners.length > 0) {
      this.linkedPartners.forEach((partner) => {
        const markerOptions = {
          position: { lat: partner.latitude, lng: partner.longitude },
          label: partner.partnerName,
          title: partner.partnerName,
          animation: google.maps.Animation.DROP,
          map: map,
        };
        var marker = new google.maps.Marker(markerOptions);
      });
    }
  };

  addListenersOnPolygon(polygon) {
    google.maps.event.addListener(polygon, 'mouseup', (event) => {
      const p = polygon.getPaths();
      for (let pp = 0; pp < p.getLength(); pp++) {
        var a = p.getAt(pp);
        this.updatePointList(a);
      }
    });
  }

  clearSelection() {
    if (this.selectedShape) {
      this.selectedShape.setEditable(false);
      this.selectedShape = null;
      this.pointList = [];
    }
  }

  setSelection(shape) {
    this.clearSelection();
    this.selectedShape = shape;
    shape.setEditable(true);
  }

  deleteSelectedShape() {
    if (this.selectedShape) {
      this.selectedShape.setMap(null);
      this.pointList = [];
      // To show the controls:
      this.drawingManager.setOptions({
        drawingControl: true,
      });
    }
  }

  getPartnerName(id) {
    var store = this.linkedPartners.find((x) => {
      return x.partnerID.toString() === id.toString();
    });
    return store ? store.partnerName : '';
  }

  searchProducts(event) {
    var results = this.products.filter(function (product) {
      return (
        product.SKU.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        product.Name.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        (product.SystemSKU !== null &&
          product.SystemSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
          -1) ||
        (product.ManufacturerSKU !== null &&
          product.ManufacturerSKU.toLowerCase().indexOf(
            event.query.toLowerCase(),
          ) > -1)
      );
    });
    results = JSON.parse(JSON.stringify(results)).map((product) => {
      product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
      product.ID = 0;
      product.Quantity = 1;
      delete product.PartnerID;
      return product;
    });

    if (results.length > 0) {
      this.searchResult = results;
    } else {
      this.searchExternal(event);
    }
  }

  searchExternal(event) {
    this.productsService
      .searchProduct(this.helpersService.getPartnerId(), event.query)
      .subscribe((results) => {
        this.searchResult = results.map((item) => {
          return {
            ID: item.ID,
            SKU: item.Description,
            Name: item.Data,
            Quantity: 1,
          };
        });
      });
  }

  linkCollectionSku(event) {
    let product = event;
    if (event.value) {
      product = event.value;
    }
    this.data.collectionProduct = {
      productID: product.ID,
      sku: product.SKU,
      name: product.Name,
    };
  }

  clearCollectionSKU() {
    this.data.collectionProduct = null;
  }

  linkDeliverySku(event) {
    let product = event;
    if (event.value) {
      product = event.value;
    }

    this.data.deliveryProduct = {
      productID: product.ID,
      sku: product.SKU,
      name: product.Name,
    };
  }

  clearDeliverySKU() {
    this.data.deliveryProduct = null;
  }

  redrawMaps(){
    console.log(this.overlays)
    for (let overlay of this.overlays) {
      overlay.setMap(null);
    }
    this.overlays = [];
    this.onMapReady(this.globalMap)
  }

  selectDeselectAllMaps(){
    this.areaColours.forEach(area=>{
      if(area.area !== this.data.areaName){
        area.showOnMap = this.showAllMaps;;
      }
    });
    this.redrawMaps();
  }
}
